import { useState } from 'react'

import { useDisclosure } from '@chakra-ui/react'

import { EditDeviceFieldsI } from '../types/types'

export const useDeviceModals = () => {
  const [deviceData, setDeviceData] = useState<EditDeviceFieldsI>(null)
  const {
    isOpen: isEditDeviceOpen,
    onOpen: onEditDeviceOpen,
    onClose: onEditDeviceClose,
  } = useDisclosure()
  const {
    isOpen: isDeleteDeviceOpen,
    onOpen: onDeleteDeviceOpen,
    onClose: onDeleteDeviceClose,
  } = useDisclosure()

  const openEditDevice = (deviceData: EditDeviceFieldsI) => {
    setDeviceData(deviceData)
    onEditDeviceOpen()
  }

  const openRemoveDevice = (deviceData: EditDeviceFieldsI) => {
    setDeviceData(deviceData)
    onDeleteDeviceOpen()
  }

  return {
    deviceData,
    isEditDeviceOpen,
    onEditDeviceClose,
    isDeleteDeviceOpen,
    openEditDevice,
    openRemoveDevice,
    onDeleteDeviceClose,
  }
}
